import { ExternalLink } from "lucide-react";
import { PAYPAL_URL } from "@/lib/content";
import { money } from "./usePrices";

export const PayPalPay = ({ amount, label }) => (
  <div data-testid="paypal-payment-panel" className="mt-8 rounded-[24px] border border-[#E6E0D4] bg-[#F4F0E8] p-6 text-left">
    <p className="text-xs uppercase tracking-[0.25em] text-[#A8613C] font-semibold">Complete your payment</p>
    <p className="mt-3 text-sm text-[#5E584F]">
      Send <span data-testid="paypal-amount" className="font-display text-2xl text-[#2D2A26]">{amount ? money(amount) : ""} USD</span> for your {label} via PayPal, and add your name in the note.
    </p>
    <div className="mt-5 flex flex-col sm:flex-row items-center gap-5">
      <img src="/img/paypal-qr.png" alt="PayPal QR code for Shaya Spiritual Practice" className="w-36 h-36 rounded-xl bg-white p-1" data-testid="paypal-qr-image" />
      <div className="flex flex-col gap-2 w-full">
        <a data-testid="paypal-pay-link" href={PAYPAL_URL} target="_blank" rel="noopener noreferrer" className="btn-pill justify-center bg-[#2D2A26] text-[#FBFBF8] hover:bg-[#A8613C] px-6 py-3.5 text-sm">
          Pay with PayPal <ExternalLink size={14} />
        </a>
        <p className="text-xs text-[#6E685F] text-center sm:text-left">Scan the code with your phone, or tap the button.</p>
      </div>
    </div>
  </div>
);
